var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`valueAndChange ${_vm.cssCls}`},[(!_vm.hideValue)?_c('div',{staticClass:"vacValue"},[_vm._v(_vm._s(_vm.value))]):_vm._e(),_c('font-awesome-icon',{attrs:{"icon":_vm.getChangeIcon}}),_c('div',{staticClass:"vacChange"},[_vm._v(_vm._s(_vm.change))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }